import React from 'react';
import { Button } from './ui/button';
import { ChevronRight, Calendar } from 'lucide-react';

export const CtaSection = () => {
  return (
    <section className="section-full bg-primary py-16 md:py-24 lg:py-32">
      <div className="container-wide text-center px-6">
        <div className="max-w-4xl mx-auto">
          {/* Date - UPDATED */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 mb-8">
            <Calendar className="text-white" size={20} />
            <span className="text-white font-bold text-sm uppercase tracking-widest">Sunday 26th July 2026</span>
          </div>

          {/* Headline */}
          <h2 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-8 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            EARLY BIRD
            <br />
            REGISTRATION
            <br />
            OPEN NOW
          </h2>

          {/* Description */}
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-12 leading-relaxed">
            Secure your spot and save with our early bird pricing. Limited spots available.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button className="btn-standard-inverse-dark group">
              Register Now
              <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform" size={22} />
            </Button>
            <Button className="btn-standard-outline-inverse">
              View Pricing
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;